// removed by extract-text-webpack-plugin
module.exports = {"container":"_73elAjgVqVTfUstqPp-Z9","title":"_3c5Y82P302XXT-7jCROFUS","name":"_1W0_alDlhdXFGmP2JymkCr","body":"B_SRDsvvAuAbsPazN5z9N"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/PlanModal/components/PlanLayout/styles.scss
// module id = 628
// module chunks = 11